import React, { useState, useRef } from "react";
import { BiSolidReport } from "react-icons/bi";

import axios from "axios";
import Swal from "sweetalert2";

const ReportProveedorAdminxmlLealtad = () => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectYear, setSelectYear] = useState("");
  const downloadLinkRef = useRef(null);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectYear(event.target.value);
  };
  const monthString = selectedMonth;
  const year = selectYear;
  // Construir la URL para la descarga del informe
  const url = `${process.env.REACT_APP_DOWNLOAD_SALES_XLSX_ADMIN_PROVEEDOR_LEALTAD}?month=${monthString}&year=${year}`;

  const handleDownloadClick = () => {
    // Realizar una solicitud GET para verificar si el recurso existe
    axios
      .get(url)
      .then(() => {
        // Si la respuesta es exitosa, activar la descarga a través del enlace oculto
        downloadLinkRef.current.click();
      })
      .catch((error) => {
        // Si hay un error (por ejemplo, 404), mostrar la alerta
        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "Datos no encontrados",
            text: "No hay ventas agregadas en ese mes o año",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No se pudo descargar el archivo.",
          });
        }
      });
  };

  return (
    <div className="boxreportallprovlealtad">
      <div className="boxreportlealtad">
        <div className="ReportsProvlealtad">
          <div className="displayboxReport-provlealtad">
            <div className="iconReportbox-provlealtad">
              <BiSolidReport className="iconreport-provlealtad" />
            </div>
            <div className="widtallreport-amebolealtad">
              <div className="widtallreport-provlealtad">
                <select
                  className="montinputreport-provlealtad"
                  value={selectYear}
                  onChange={handleYearChange}
                >
                  <option value="">Selecciona un año</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                  <option value="2028">2028</option>
                  <option value="2029">2029</option>
                  <option value="2030">2030</option>
                  <option value="2031">2031</option>
                  <option value="2032">2032</option>
                  <option value="2033">2033</option>
                  <option value="2034">2034</option>
                </select>
              </div>
              <div className="boxinputreport-provlealtad">
                <select
                  className="montinputreport-provlealtad"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                >
                  <option value="">Selecciona un mes</option>
                  <option value="01">Enero</option>
                  <option value="02">Febrero</option>
                  <option value="03">Marzo</option>
                  <option value="04">Abril</option>
                  <option value="05">Mayo</option>
                  <option value="06">Junio</option>
                  <option value="07">Julio</option>
                  <option value="08">Agosto</option>
                  <option value="09">Septiembre</option>
                  <option value="10">Octubre</option>
                  <option value="11">Noviembre</option>
                  <option value="12">Diciembre</option>
                </select>
              </div>
              <div className="boxinputbuttonreport-amebolealtad">
                <a
                  ref={downloadLinkRef}
                  href={url}
                  download
                  style={{ display: "none" }}
                >
                  Descargar
                </a>
                <button
                  className="buttonreport-provlealtad"
                  onClick={handleDownloadClick}
                >
                  Descargar proveedor
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportProveedorAdminxmlLealtad;
